<script setup>
const props = defineProps({
    value: Number
})
</script>

<template>
    <i v-if="value" class="bi-check-lg"/>
</template>